
<section id="taskboard" class="app-taskboard">
  
  <div>
    <h5 class="mt-2 mb-0">
      <span class="d-flex align-items-center">
        <i class="ft-cast mr-2"></i>
        <span>All Tasks</span>
      </span>
    </h5>
    <div class="row">
      <div class="col-xl-3 col-sm-6 col-12" *ngFor='let item of taskData_normal'>
   
        <div *ngIf="taskData_normal?.length>0" class='container'>
          <div class="card mb-3" >
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="task-title" [ngClass]="{'bg-light-danger': item?.is_mandatory === 'yes'}">{{item?.title}}</span>
              </div>
              <div class="d-flex mb-2">
                <span class="badge task-chips1">{{item?.type_projects[0]?.name}}</span>
                </div>
              <div class="d-flex mb-2 task-chips">
                <span class="badge bg-light-info">{{item?.priority[0]?.displayname}}</span>
                <span class="badge bg-light-success">{{item?.label[0]?.displayname}}</span>
                <span class="badge bg-light-primary">{{item?.working_hours}} Hour</span>
                <span class="badge bg-light-warning">Schedule-Date {{item?.scheduleduration | date:'shortDate'}}</span>
              </div>
              <div class="task-body mb-2">
                <p>{{item.body}}</p>
              </div>
              <!-- <div>
                <span class="badge bg-light-warning mr-2">Schedule-Date {{item?.scheduleduration | date:'shortDate'}}</span>
              </div> -->
              <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div>
            </div>
          </div>
         
        </div>
      
    </div>
    </div>
 
<!-- 
    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>In-Review</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"'>
        <div class="card mb-3" *ngFor='let item of taskData_medium'>
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="badge bg-light-success mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit mr-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
              </div>
            </div>
            <div>
              <span class="badge bg-light-info mb-2">{{item?.title}}</span>
            </div>
            <p>{{item.body}}</p>
            <div *ngIf="task.messageType === 'image'"
              class="d-flex justify-content-center overflow-hidden rounded my-3">
              <img [src]="task.taskMessage" alt="ToDo Pic" height="350">
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div> -->
                <!-- <div class="mr-2" *ngIf="task.messageCount != ''"><i
                    class="ft-message-square mr-1"></i>{{task.messageCount}}</div>
                <div *ngIf="task.linkCount != ''"><i class="ft-link mr-1"></i>{{task.linkCount}}</div> -->
              <!-- </div> -->
              <!-- <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="task.isUserImg">
                <li *ngFor="let img of task.assignedTo">
                  <img class="rounded-circle" [src]="img" alt="Avatar" height="24" width="24">
                </li>
              </ul>
              <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="!task.isUserImg">
                <li *ngFor="let badge of task.assignedTo">
                  <span class="badge badge-pill badge-round bg-light-{{badge.class}} font-small-1">{{badge.name}}</span>
                </li>
              </ul> -->
            <!-- </div>
          </div>
        </div> -->
        <!-- <div *ngFor="let item of taskData">
          <div class="handle">Drag Handle</div>
          <div>{{ item.title }}</div>
        </div> -->
      <!-- </div>
    </div> -->

    <!-- <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Pending</span>
        </span>
      </h5>
      <div class="box" *ngIf="user_data?.next_task !=='' && user_role !=='student'">
        <div class="card-body">
          <div >
            <div class="d-flex justify-content-between mb-2">
              <span class="task-title">Next Task</span>
            </div> -->
            <!-- <div class="d-flex mb-2 task-chips">
              <span class="badge bg-light-warning">Urgent</span>
            </div> -->
            <!-- <div class="task-body mb-2">
              <span [innerText]="user_data?.next_task"></span>
            </div>
            <div class="mr-2" *ngIf="user_data?.updated_at">
              <i class="ft-clock mr-1"></i>{{user_data?.created_at | date:'medium'}}</div>
          </div> -->
          <!-- <div class="d-flex justify-content-between mb-2">
            <span> Next Task : <span class="task-title" [innerText]="user_data?.next_task"></span></span>
          </div> -->
          
        <!-- </div>
      </div>
      <div *ngIf="taskData_high" class='dragdrop-container' [dragula]='"ITEMS"'>
        <div class="card mb-3" *ngFor='let item of taskData_high'>
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="badge bg-light-warning mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit mr-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
              </div>
            </div>
            <div>
              <span class="badge bg-light-info mb-2">{{item?.title}}</span>
            </div>
            <p>{{item.body}}</p> -->
            <!-- <div *ngIf="task.messageType === 'image'"
              class="d-flex justify-content-center overflow-hidden rounded my-3">
              <img [src]="task.taskMessage" alt="ToDo Pic" height="350">
            </div> -->
            <!-- <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2">
                <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div> -->
                <!-- <div class="mr-2" *ngIf="task.messageCount != ''"><i
                    class="ft-message-square mr-1"></i>{{task.messageCount}}</div>
                <div *ngIf="task.linkCount != ''"><i class="ft-link mr-1"></i>{{task.linkCount}}</div> -->
              <!-- </div> -->
              <!-- <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="task.isUserImg">
                <li *ngFor="let img of task.assignedTo">
                  <img class="rounded-circle" [src]="img" alt="Avatar" height="24" width="24">
                </li>
              </ul>
              <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="!task.isUserImg">
                <li *ngFor="let badge of task.assignedTo">
                  <span class="badge badge-pill badge-round bg-light-{{badge.class}} font-small-1">{{badge.name}}</span>
                </li>
              </ul> -->
            <!-- </div>
          </div>
        </div> -->
        <!-- <div *ngFor="let item of taskData">
          <div class="handle">Drag Handle</div>
          <div>{{ item.title }}</div>
        </div> -->
      <!-- </div>
    </div>
    <div class="col-xl-3 col-sm-6 col-12">
      <h5 class="mt-2 mb-0">
        <span class="d-flex align-items-center">
          <i class="ft-cast mr-2"></i>
          <span>Completed</span>
        </span>
      </h5>
      <div class='dragdrop-container' [dragula]='"ITEMS"'>
        <div class="card mb-3" *ngFor='let item of taskData_urgent'>
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="badge bg-light-danger mr-2" *ngFor="let item of item?.to">{{item?.name}}</span>
              <div class="edit-del-btn">
                <i class="ft-edit mr-1 primary cursor-pointer" [routerLink]="['/task/edit',item._id]"></i>
                <i class="ft-trash-2 danger cursor-pointer" (click)="confirmDelete(item._id);"></i>
              </div>
            </div>
            <div>
              <span class="badge bg-light-info mb-2">{{item?.title}}</span>
            </div>
            <p>{{item.body}}</p> -->
            <!-- <div *ngIf="task.messageType === 'image'"
              class="d-flex justify-content-center overflow-hidden rounded my-3">
              <img [src]="task.taskMessage" alt="ToDo Pic" height="350">
            </div> -->
            <!-- <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex font-small-2"> -->
                <!-- <div class="mr-2" *ngIf="item.created_at!= ''"><i class="ft-clock mr-1"></i>{{item.created_at | date:'medium'}}</div> -->
                <!-- <div class="mr-2" *ngIf="task.messageCount != ''"><i
                    class="ft-message-square mr-1"></i>{{task.messageCount}}</div>
                <div *ngIf="task.linkCount != ''"><i class="ft-link mr-1"></i>{{task.linkCount}}</div> -->
              <!-- </div> -->
              <!-- <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="task.isUserImg">
                <li *ngFor="let img of task.assignedTo">
                  <img class="rounded-circle" [src]="img" alt="Avatar" height="24" width="24">
                </li>
              </ul>
              <ul class="list-unstyled users-list m-0 d-flex align-items-center" *ngIf="!task.isUserImg">
                <li *ngFor="let badge of task.assignedTo">
                  <span class="badge badge-pill badge-round bg-light-{{badge.class}} font-small-1">{{badge.name}}</span>
                </li>
              </ul> -->
        <!-- <div *ngFor="let item of taskData">
          <div class="handle">Drag Handle</div>
          <div>{{ item.title }}</div>
        </div> -->
      <!-- </div>
    </div> -->

  </div>
</section>
